import { Call, StreamVideoClient } from '@stream-io/video-react-sdk';

export type State = {
  apiKey?: string;
  userId?: string;
  userName?: string;
  userToken?: string;
  callId: string;
  call?: Call;
  callState?: object;
  client?: StreamVideoClient;
  loading: boolean;
  feedback?: {
    type: string;
    msg: string;
  };
  step: number;
  customControls: boolean;
  hasJoined: boolean;
};

export type Action =
  | { type: Actions.SetLoading; loading: boolean }
  | { type: Actions.SetStep; step: Step }
  | { type: Actions.SetCustomControls; customControls: boolean }
  | { type: Actions.SetJoined; joined: boolean }
  | { type: Actions.SetCall; call: Call }
  | { type: Actions.SetCallState; callState: object }
  | {
      type: Actions.SetClientUser;
      api_key: string;
      user_id: string;
      user_name: string;
      user_token: string;
    }
  | {
      type: Actions.SetClient;
      client: any;
    }
  | { type: Actions.SetFeedback; feedback: { type: string; msg: string } }
  | { type: Actions.ClearFeedback }
  | { type: Actions.SetError; error: any };

export enum Actions {
  SetClientUser = 'setClientUser',
  SetCustomControls = 'setCustomControls',
  SetJoined = 'setJoined',
  SetCall = 'setCall',
  SetCallState = 'setCallState',
  SetClient = 'setClient',
  SetStep = 'setStep',
  SetFeedback = 'setFeedback',
  ClearFeedback = 'clearFeedback',
  SetError = 'setError',
  SetLoading = 'setLoading',
}
